import {
  IWebexIntCallableEntity,
  IWebexIntContact,
} from '@webex/component-adapter-interfaces/dist/esm/src';
import { IGraphUser } from '../service/MsTeamsUserService';

export enum CallableType {
  EMAIL = 'mail',
  MOBILE = 'mobile',
  WORK = 'work',
  HOME = 'home',
  EXTENSION = 'extension',
  FAX = 'fax',
}

/** Map DSS/Graph phone type to CallableType for UI (Work, Mobile, Extension, Fax). */
function toCallableType(t: string): string {
  const normalized = (t ?? '').toLowerCase();
  if (normalized === 'extension' || normalized === 'work_extension') return CallableType.EXTENSION;
  if (normalized === 'mobile') return CallableType.MOBILE;
  if (normalized === 'fax' || normalized === 'facsimile' || normalized === 'facsimiletelephonenumber') {
    return CallableType.FAX;
  }
  if (normalized === 'work' || normalized === 'home') return normalized;
  return CallableType.WORK;
}

export const transformGraphUser = (
  graphUser: IGraphUser,
  fetchAvatarUrl?: () => Promise<string | undefined>
): IWebexIntContact => {
  const emails: IWebexIntCallableEntity[] = [
    ...(graphUser.emailAddresses || [])
      .map((emailObj) => emailObj.address)
      .concat(graphUser.mail ? [graphUser.mail] : [])
      .map((email) => ({
        type: CallableType.EMAIL,
        address: email,
      })),
  ];

  let phoneNumbers: IWebexIntCallableEntity[];

  if (graphUser.phoneNumbersWithType && graphUser.phoneNumbersWithType.length > 0) {
    phoneNumbers = graphUser.phoneNumbersWithType.map((p) => ({
      type: toCallableType(p.type),
      address: p.value,
    }));
  } else {
    phoneNumbers = [
      ...(graphUser.businessPhones || []).map((number) => ({
        type: CallableType.WORK,
        address: number,
      })),
    ];
    if (graphUser.mobilePhone) {
      phoneNumbers.push({
        type: CallableType.MOBILE,
        address: graphUser.mobilePhone,
      });
    }
    if (graphUser.homePhones && graphUser.homePhones.length > 0) {
      graphUser.homePhones.forEach((number) => {
        phoneNumbers.push({
          type: CallableType.HOME,
          address: number,
        });
      });
    }
  }

  return {
    id: graphUser.id,
    phoneNumbers,
    emailAddresses: emails,
    name: graphUser.displayName,
    fetchAvatarUrl,
    ...(graphUser.fromDss ? { fromDss: true as const } : {}),
  };
};
